import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';

import spacing from '@decisiv/design-tokens/lib/spacing';

import Flex from '@decisiv/ui-components/lib/components/Flex';

export const Row = styled(Flex)`
  align-items: center;
  gap: ${rem(spacing.base * 1)};
  margin-top: ${rem(spacing.base * 1.5)};
`;

export const HiddenFileInput = styled.input`
  display: none;
`;
